(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335,346],{

/***/ 97910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconExternal = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M16 12.73V8.285h-.9v4.415a2.402 2.402 0 0 1-2.398 2.4H3.298A2.402 2.402 0 0 1 .9 12.7V3.298A2.402 2.402 0 0 1 3.298.9h4.39V0h-4.39A3.292 3.292 0 0 0 0 3.298v9.404A3.292 3.292 0 0 0 3.298 16h9.404C14.527 16 16 14.527 16 12.73Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15.1 4.825v-3.27L8.068 8.587l-.654-.654L14.447.901h-3.271V0H16v4.824h-.9Z",
  fill: "#B18D3B"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconExternal);

/***/ }),

/***/ 66405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(34695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70539);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40050);
/* harmony import */ var _custom_Highlight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(958);
/* harmony import */ var _custom_Staff__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33528);
/* harmony import */ var _components_ContactForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64150);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61137);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34495);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79697);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(117);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);


















var Contact = function(param) {
    var title = param.title, description = param.description, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, _buying = param.buying, buying = _buying === void 0 ? true : _buying, _separator = param.separator, separator = _separator === void 0 ? true : _separator, staff = param.staff, _leftLabel = param.leftLabel, leftLabel = _leftLabel === void 0 ? true : _leftLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sectionRef = param.sectionRef, route = param.route, translations = param.translations;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__/* .useResponsive */ .F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var isGeneral = variant.includes("general");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            sectionRef: sectionRef,
            separator: separator,
            variant: [
                variant.includes("gray") ? "gray" : "white"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: [
                        isTablet ? "-align-center" : "-distribute-between"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 7 : 6,
                            children: [
                                leftLabel && staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro", [
                                        isGeneral && "general",
                                        !leftLabel && "offset-top"
                                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default())),
                                    children: leftLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            " ",
                                            translations.interestedIn[router.locale],
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                variant: [
                                                    "accent",
                                                    "font-primary"
                                                ],
                                                children: translations.buying[router.locale]
                                            }),
                                            " ",
                                            translations.property[router.locale]
                                        ]
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && staff.map(function(person, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Staff__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                            width: isSmallMobile && 168,
                                            height: isSmallMobile && 308,
                                            variant: [
                                                "inline",
                                                "align-middle"
                                            ]
                                        }, person), {
                                            job: person.job[router.locale]
                                        }), "contact-staff-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 11 : 6,
                            children: [
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().description),
                                    children: description
                                }),
                                isGeneral || title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    children: title || translations.assistance[router.locale]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().intro), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().last)),
                                    children: [
                                        translations.interestedIn[router.locale],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            variant: [
                                                "font-primary",
                                                buying && "accent"
                                            ],
                                            children: buying ? translations.buying[router.locale] : translations.renting[router.locale]
                                        }),
                                        translations.thisProperty[router.locale]
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    route: route,
                                    translations: translations,
                                    disabled: disabled
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 15005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ single_property_Map; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(28499);
// EXTERNAL MODULE: ./components/pages/single-property/Map/styles.module.scss
var styles_module = __webpack_require__(98925);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-marker.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMarker = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 14,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M7.014 20.153c3.171 0 6.433-2.287 6.433-6.153 0-2.16-1.117-3.656-3.495-4.802-1.085-.528-2.287-.935-3.32-1.405C4.546 6.885 3.96 5.828 3.96 4.45c0-1.727 1.117-2.842 2.79-2.842 1.911 0 3.643 1.574 5.258 4.801l.588-.09-.498-5.74h-.498l-1.144.992c-.969-.56-1.97-.966-3.436-.966-2.965 0-5.994 2.112-5.994 5.598 0 2.14 1.086 3.75 3.145 4.775.911.439 1.997.819 2.939 1.204 2.759 1.141 3.437 1.992 3.437 3.75 0 1.85-1.234 3.223-3.352 3.223s-4.2-1.347-6.052-5.568l-.615.059.35 6.507h.53l1.143-1.025a9.91 9.91 0 0 0 4.464 1.025Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_marker = (SvgIconMarker);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/pages/single-property/Map/index.js









// to be moved to elements Map
var Map = function(param) {
    var lat = param.lat, lng = param.lng, points = param.points, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    var ref, ref1;
    var ref2 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref2.isMobile, isTablet = ref2.isTablet;
    var ref3 = (0,react.useState)(false), maps = ref3[0], setMaps = ref3[1];
    var hasSection = variant.includes("section");
    var ref4 = (0,react.useState)(false), loaded = ref4[0], setLoaded = ref4[1];
    var isMountedRef = (0,react.useRef)(true);
    // Cleanup on unmount to prevent Google Maps internal errors
    (0,react.useEffect)(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    var Marker = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).map__marker,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_marker, {})
        });
    };
    (0,react.useEffect)(function() {
        var onPageLoad = function() {
            setLoaded(true);
        };
        // Check if the page has already loaded
        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad);
            // Remove the event listener when component unmounts
            return function() {
                return window.removeEventListener("load", onPageLoad);
            };
        }
    }, []);
    if (!loaded && (!lng || !lat || points)) {
        return;
    }
    var defaultProps = {
        center: {
            lat: Number(lat) || Number((ref = points[0]) === null || ref === void 0 ? void 0 : ref.lat),
            lng: points ? Number((ref1 = points[0]) === null || ref1 === void 0 ? void 0 : ref1.lng) : Number(lng)
        },
        zoom: isMobile ? 12 : 13
    };
    if (hasSection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            className: (styles_module_default()).section,
            variant: [
                "p0"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                variant: [
                    isTablet && "-p0"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).map,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
                        bootstrapURLKeys: {
                            // eslint-disable-next-line no-undef
                            key: "AIzaSyCYNyhjZek7H1qMVK4kJB3M6jTokrr7FDs"
                        },
                        onGoogleApiLoaded: function(param) {
                            var maps = param.maps;
                            if (isMountedRef.current) setMaps(maps);
                        },
                        options: {
                            mapTypeControl: true,
                            mapTypeControlOptions: maps && {
                                mapTypeIds: [
                                    maps.MapTypeId.ROADMAP,
                                    maps.MapTypeId.SATELLITE
                                ]
                            }
                        },
                        yesIWantToUseGoogleMapApiInternals: true,
                        center: defaultProps.center,
                        zoom: defaultProps.zoom,
                        children: points ? points.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                lng: item.lng,
                                lat: item.lat
                            }, index);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                            lng: lng,
                            lat: lat
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,withModifiers/* withModifiers */.i)("map", [
            "full-width"
        ], (styles_module_default())),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
            bootstrapURLKeys: {
                // eslint-disable-next-line no-undef
                key: "AIzaSyCYNyhjZek7H1qMVK4kJB3M6jTokrr7FDs"
            },
            yesIWantToUseGoogleMapApiInternals: true,
            center: defaultProps.center,
            zoom: defaultProps.zoom,
            onGoogleApiLoaded: function(param) {
                var maps = param.maps;
                if (isMountedRef.current) setMaps(maps);
            },
            options: {
                mapTypeControl: true,
                mapTypeControlOptions: maps && {
                    mapTypeIds: [
                        maps.MapTypeId.ROADMAP,
                        maps.MapTypeId.SATELLITE
                    ]
                }
            },
            children: points ? points.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                    lng: item.lng,
                    lat: item.lat
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                lng: lng,
                lat: lat
            })
        })
    });
};
/* harmony default export */ var single_property_Map = (Map);


/***/ }),

/***/ 34695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_Page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51904);
/* harmony import */ var _components_elements_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24447);
/* harmony import */ var _components_elements_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51524);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(13712);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70539);
/* harmony import */ var _components_layout_Columns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40050);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40670);
/* harmony import */ var _components_pages_single_property_Map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15005);
/* harmony import */ var _components_elements_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41197);
/* harmony import */ var _components_pages_common_Contact__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90346);
/* harmony import */ var _public_icons_icon_external_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97910);
/* harmony import */ var _components_custom_SocialConnect__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56218);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);














var Contact = function(param) {
    var pageData = param.pageData, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, ctaTranslation = param.ctaTranslation, contactTranslation = param.contactTranslation, translations = param.translations;
    var isMobile = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__/* .useResponsive */ .F)().isMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_Page__WEBPACK_IMPORTED_MODULE_1__["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        ctaTranslation: ctaTranslation,
        footer: false,
        meta: {
            title: translations.seo.title[router.locale],
            description: translations.seo.description[router.locale]
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: translations.page.title[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().subtitle),
                            children: translations.page.subtitle[router.locale]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().separator),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().separator__line)
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Columns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                spans: isMobile ? 12 : 4,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().label),
                                        children: translations.page.call[router.locale]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
                                        rel: "nofollow",
                                        href: "tel:+1 213-805-0840",
                                        children: "+1 213-805-0840"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                spans: isMobile ? 12 : 4,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().label),
                                        children: translations.page.email[router.locale]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
                                        rel: "nofollow",
                                        href: "mailto: reservations@sxmsir.com",
                                        children: "reservations@sxmsir.com"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                spans: isMobile ? 12 : 4,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().label),
                                        children: [
                                            "c",
                                            translations.page.connect[router.locale]
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_custom_SocialConnect__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_2__["default"], {
                separator: true,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().section),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().label),
                            children: translations.page.driving[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().directions),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                    variant: [
                                        "label"
                                    ],
                                    target: "_blank",
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().button),
                                    href: "https://www.google.com/maps/place/St.+Maarten+Sotheby's+International+Realty/@18.0526657,-63.1387348,17z/data=!3m1!4b1!4m5!3m4!1s0x8c0e6914e99b639b:0x4f2f113153a2f916!8m2!3d18.0526657!4d-63.1365461",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_external_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                        "Cupecoy, Sint Maarten"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                    variant: [
                                        "label"
                                    ],
                                    target: "_blank",
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().button),
                                    href: "https://www.google.com/maps/place/18%C2%B003'37.6%22N+63%C2%B005'15.0%22W/@18.0604474,-63.0880504,19z/data=!4m5!3m4!1s0x0:0xae19e4785ba1578b!8m2!3d18.0604474!4d-63.0875019",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_external_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                        "Bellevue, St. Martin"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_single_property_Map__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            points: [
                                {
                                    lat: "18.0526657",
                                    lng: "-63.1365461"
                                },
                                {
                                    lat: "18.06044735739605",
                                    lng: "-63.08750191132895"
                                }
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_common_Contact__WEBPACK_IMPORTED_MODULE_9__["default"], {
                translations: contactTranslation,
                staff: pageData,
                separator: false,
                variant: [
                    "general"
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 61137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__R0Yt_","intro":"styles_intro__e1Is4","contact":"styles_contact___xZ2x","last":"styles_last__LjZl_","intro--general":"styles_intro--general__85IDi","intro--offset-top":"styles_intro--offset-top__l7dZT","title":"styles_title__HCVSt","description":"styles_description__T7k67","staff":"styles_staff__gQuG0","name":"styles_name__nWG3U","position":"styles_position__RkAOQ","label":"styles_label___1bq_","button":"styles_button__nXKqX","position--general":"styles_position--general__OycEg"};

/***/ }),

/***/ 98925:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__q4qlr","map--full-width":"styles_map--full-width__qJPbm","map__marker":"styles_map__marker__qjYlo","section":"styles_section__nJUaP"};

/***/ }),

/***/ 13712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__UAop6","separator":"styles_separator__cmKUG","separator__line":"styles_separator__line__vywEe","label":"styles_label__c_YNp","subtitle":"styles_subtitle__IIG9x","link":"styles_link__uPKjv","directions":"styles_directions__977sW","button":"styles_button__5ymh2"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,5675,7549,6820,8433,3808,6622,8094,3817,7713,8174,9774,945,2888,179], function() { return __webpack_exec__(66405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);